// Analista — Redação (aceitar, ler folha, lançar nota ou eliminação)

import React from 'react';
import { ExamAnalystTaskQueue } from '../../components/analyst/ExamAnalystTaskQueue';
import { ExamEssayGradeEntryModal } from '../../components/admin/ExamEssayGradeEntryModal';

export const ExamEssayAnalysis = React.memo(() => (
  <ExamAnalystTaskQueue
    taskType="essay"
    title="Correção de redação"
    description="Inscrições no corte da redação atribuídas a você. Aceite a tarefa, consulte o PDF da folha e lance a nota ou registre eliminação. A situação reflete automaticamente na área do administrador."
    processFilter={(p) => p.selection_mode === 'prova' && p.exam_uses_essay && p.release_grades_manual}
    GradeModal={ExamEssayGradeEntryModal}
  />
));
